import { Accordion } from '../../../../../components/general/accordion';
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation';
import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import DateTimePickerField from '../../../../../components/general/fields/dateTimePickerField';
import dayjs from 'dayjs';
import { FunctionariesSwitchRegisterHistoryProps } from './props';
import { useFunctionariesSwitchRegisterHistory } from './hook';

export const FunctionariesSwitchRegisterHistory = ({
    functionariesSwitch,
}: FunctionariesSwitchRegisterHistoryProps) => {
    const { formik } =
        useFunctionariesSwitchRegisterHistory(functionariesSwitch);

    return (
        <Accordion
            title="REGISTRO"
            icon={<InsertInvitationIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={6}>
                    <FieldText
                        label="Creado por"
                        name="createdBy"
                        size="small"
                        value={formik.values.createdBy}
                        onChange={console.log}
                        disabled
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <DateTimePickerField
                        label="Fecha de creación"
                        name="createdAt"
                        size="small"
                        value={
                            functionariesSwitch?.created_at
                                ? dayjs(
                                    functionariesSwitch.created_at
                                ).subtract(5, 'h')
                                : null
                        }
                        disabled
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <FieldText
                        label="Modificado por"
                        name="updatedBy"
                        size="small"
                        value={formik.values.updatedBy}
                        disabled
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <DateTimePickerField
                        label="Fecha de modificación"
                        name="updatedAt"
                        size="small"
                        value={
                            functionariesSwitch?.updated_at
                                ? dayjs(
                                    functionariesSwitch.updated_at
                                ).subtract(5, 'h')
                                : null
                        }
                        disabled
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
